var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import style from './index.module.scss';
var cx = classnames.bind(style);
function ToggleFilter(props) {
    var panelVisible = props.panelVisible, toggleHandler = props.toggleHandler;
    return (_jsx("div", __assign({ className: cx('toggle-panel', { 'shown': !panelVisible }) }, { children: _jsx("span", __assign({ className: cx('selected'), onClick: function () { return toggleHandler(!panelVisible); } }, { children: !panelVisible ? 'Show more filters' : 'Hide filters' }), void 0) }), void 0));
}
export default ToggleFilter;
